import { gql } from '@apollo/client';

const GET_TEACHING_ORDERS = gql`
  query {
    teachingOrders {
      id
      name
      active
      characters {
        id
        character
        characterCase
        characterType
      }
    }
  }
`;

export default GET_TEACHING_ORDERS;
